export const apiUrl =
  process.env.REACT_APP_API_URL || "https://eva.noretest.com";
export const tokenKey = "__auth-token__";

export const font = "'Open Sans', sans-serif";
export const defaultColor = "#983670";
export const defaultSecondaryColor = "#182F74";
